import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureArrival } from "@/lib/firstPartyAnalytics";

captureArrival();

createRoot(document.getElementById("root")!).render(<App />);
